import { render, staticRenderFns } from "./PaymentGatway.vue?vue&type=template&id=1a692ac7"
import script from "./PaymentGatway.vue?vue&type=script&lang=js"
export * from "./PaymentGatway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports